import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-organizations",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id", "alt", "src"]
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "btn-label" }
const _hoisted_12 = { class: "btn-text" }
const _hoisted_13 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_16 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "pagination-wrapper mt-1" }
const _hoisted_19 = { class: "loader-div-40" }
const _hoisted_20 = ["src"]

import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElDivider,
} from "element-plus";
import { onBeforeMount, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  authInfo,
  hasPermission,
  updateMultiplePreference,
  updateSinglePreference,
} from "@/core/auth";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { router } from "@/core/router";
import {
  deleteOrganization,
  getOrganizationList,
  getOrganizationListing,
  inlineEditOrganization,
} from "@/organization/services/organization.service";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { getOrganizationRoles } from "@/core/auth/user-role";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Organizations',
  setup(__props) {

const search = ref("");
const organizationsRequestGuard = useLatestRequestGuard();

const { t } = i18n.global;
const organizationList = ref([]);
const loadingOrganizations = ref(false);
const hoverId = ref("");
const animate = ref(false);
const editMode = ref(false);

const sortField = ref(
  getPreferenceValue("organizationsSortField")
    ? getPreferenceValue("organizationsSortField")
    : "createdAt"
);

const sortAscending = ref(
  getPreferenceValue("organizationsSortOrder")
    ? getPreferenceValue("organizationsSortOrder")
    : "ascending"
);

const perPageOrganizations = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);

const currentPageOrganizations = ref(1);

const scrollInterval = ref();

const newObject = ref({
  name: undefined,
  id: undefined,
  active: undefined,
});

const numberOfOrganizations = ref(0);

const { onSearchInput } = useDebouncedSearch(getOrganizations);

function sizeChanged(val) {
  perPageOrganizations.value = val;
  updateSinglePreference("pageSize", val);
  getOrganizations();
}

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    organizationsSortField: sort.prop,
    organizationsSortOrder: sort.order,
  });
  getOrganizations();
}

function openEditMode(row) {
  animate.value = false;
  if (
    newObject.value.id !== row.id &&
    hasPermission("TENANTS.LIST.INLINE.EDIT")
  ) {
    newObject.value = cloneDeep(row);
    editMode.value = true;
  }
}

function closeEditMode() {
  editMode.value = false;
  newObject.value = {
    name: undefined,
    id: undefined,
    active: undefined,
  };
}

function cellMouseEnter(row, scope) {
  hoverId.value = row.id;
  const logoDiv = document.getElementById(`logo-div-${row.id}`);
  if (scope.no === 1 && logoDiv) {
    if (logoDiv.scrollLeft > 0) {
      scrollInterval.value = setInterval(() => {
        logoDiv.scrollTo(logoDiv.scrollLeft - 2, 0);
      }, 15);
    } else {
      scrollInterval.value = setInterval(() => {
        logoDiv.scrollTo(logoDiv.scrollLeft + 2, 0);
      }, 15);
    }
  }
}

function cellMouseLeave() {
  hoverId.value = "";
  if (scrollInterval.value) {
    clearInterval(scrollInterval.value);
  }
}

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

async function changeActiveStatus(organization) {
  if (hasPermission("ORGANIZATIONS.LIST.INLINE.CHANGE_ACTIVE")) {
    const result = await inLineEditOrganization(organization);
    if (result) {
      if (organization.active) {
        showAlert(TYPE.SUCCESS, t("Organization.OrgActivated"));
      } else {
        showAlert(TYPE.WARNING, t("Organization.OrgDeActivated"));
      }
    }
  }
}

async function editSelectedOrganization() {
  if (
    editMode.value &&
    newObject.value.name &&
    hasPermission("ORGANIZATIONS.LIST.INLINE.EDIT")
  ) {
    const result = await inLineEditOrganization(newObject.value);
    if (result) {
      editMode.value = false;
      newObject.value = {
        name: undefined,
        id: undefined,
        active: undefined,
      };
      organizationList.value = await getOrganizationList();
      showAlert(TYPE.SUCCESS, t("Organization.OrgUpdated"));
    } else {
      showAlert(TYPE.ERROR, t("Organization.OrgAlreadyExists"));
    }
  } else if (hasPermission("ORGANIZATIONS.TABLE.INLINE.EDIT")) {
    showAlert(TYPE.WARNING, t("Common.WarningName"));
  }
}

async function inLineEditOrganization(organization) {
  let result = false;
  await inlineEditOrganization(organization).then(async (response) => {
    if (response.code === 200) {
      showAlert(TYPE.SUCCESS, t("Organization.OrgUpdated"));
      await getOrganizationRoles(authInfo.value.userId);
      result = true;
    } else if (response.code === 409) {
      showAlert(TYPE.ERROR, t("Organization.OrgAlreadyExists"));
    }
  });
  return result;
}

function goToEditPage(row) {
  if (
    hasPermission("ORGANIZATIONS.LIST.EDIT") &&
    newObject.value.id !== row.id
  ) {
    router.push(`/organizations/edit/${row.id}`);
  } else if (newObject.value.id === row.id) {
    animate.value = true;
    setTimeout(() => {
      animate.value = false;
    }, 2200);
  }
}

async function getOrganizations() {
  const requestToken = organizationsRequestGuard.start();
  loadingOrganizations.value = true;

  const params = {
    pageNumber: currentPageOrganizations.value - 1,
    pageSize: perPageOrganizations.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
    search: search.value,
  };

  try {
    const page = await getOrganizationListing(params);
    if (!page) {
      console.error("Failed to get organization listing.");
      return;
    }
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!organizationsRequestGuard.isLatest(requestToken)) {
      return;
    }
    organizationList.value = page.data;
    numberOfOrganizations.value = page.totalElements;
  } catch (error) {
    console.error("Error fetching organizations:", error);
  } finally {
    if (organizationsRequestGuard.isLatest(requestToken)) {
      loadingOrganizations.value = false;
    }
  }
}

async function deleteSelectedOrganization(organization) {
  if (hasPermission("ORGANIZATIONS.LIST.REMOVE")) {
    const isConfirmed = await showConfirm(
      "warning",
      t("Organization.DeleteOrg"),
      t("Organization.DeleteOrgWarning", { name: organization.name })
    );
    if (isConfirmed) {
      organization.loading = true;
      const response = await deleteOrganization(organization.id);
      organization.loading = false;
      if (response.code === 200) {
        const orgName = organization.name;
        showAlert(
          TYPE.SUCCESS,
          t(`${orgName}`) + t("Organization.ORG_DELETE_SUCCESS")
        );
        await getOrganizations();
        await getOrganizationRoles(authInfo.value.userId);
      } else {
        organization.loading = false;
        const errorCode = response.result.error;
        const errorMsg =
          t(`Organization.${errorCode}`) || t("Organization.DeleteOrgFailed");
        showAlert(TYPE.ERROR, errorMsg);
      }
    }
  }
}

onBeforeMount(() => {
  getOrganizations();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), { class: "card border-0 oneTeg-card oneTeg-card-body" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTable), {
          data: organizationList.value,
          "default-sort": { prop: sortField.value, order: sortAscending.value },
          "empty-text": loadingOrganizations.value ? ' ' : 'No Data',
          class: "oneTeg-table",
          "row-class-name": 
          _unref(hasPermission)('ORGANIZATIONS.LIST.EDIT')
            ? 'oneTeg-table-row-permission'
            : 'oneTeg-table-row-no-permission'
        ,
          height: "97%",
          onRowClick: goToEditPage,
          onCellMouseEnter: cellMouseEnter,
          onCellMouseLeave: cellMouseLeave,
          onSortChange: sortChanged
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Name'),
              prop: "name",
              sortable: "custom",
              width: "300px"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      id: 'inline-edit-name-input-' + scope.$index,
                      modelValue: newObject.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newObject.value.name) = $event)),
                      placeholder: _unref(t)('Common.Name'),
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["id", "modelValue", "placeholder"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      id: 'name-' + scope.$index
                    }, [
                      _createElementVNode("strong", {
                        id: 'name-label-' + scope.$index
                      }, _toDisplayString(scope.row.name), 9, _hoisted_3),
                      (
                  _unref(hasPermission)('ORGANIZATIONS.LIST.INLINE.EDIT') &&
                  scope.row.id === hoverId.value
                )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            id: 'inline-edit-icon-' + scope.$index,
                            class: "pencil-span",
                            onClick: _withModifiers(($event: any) => (openEditMode(scope.row)), ["stop"])
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                          ], 8, _hoisted_4))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_2))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Connectors'),
              prop: "connectors",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (scope.row.connectors.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: 'logo-div-' + scope.row.id,
                      class: "d-flex flex-row logo-strip"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.connectors, (connector, index) => {
                        return (_openBlock(), _createElementBlock("img", {
                          id: 'icon-' + scope.$index + '-' + index,
                          key: connector.id,
                          alt: connector.name,
                          src: `${_unref(ASSETS_BASE_URL)}/${
                  connector.connectorSpecId
                }${_unref(getResolution)(false)}.png`,
                          class: "logo-l margin-right-10"
                        }, null, 8, _hoisted_6))
                      }), 128))
                    ], 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      id: 'logo-div-' + scope.row.id,
                      class: "d-flex flex-row logo-strip"
                    }, _toDisplayString(_unref(t)("Common.NoSelectedConnector")), 9, _hoisted_7))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.CreationTime'),
              prop: "createdAt",
              sortable: "custom",
              width: "150px",
              class: "max-w-170"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(convertDate(scope.row.createdAt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Active'),
              prop: "active",
              width: "130px"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 0,
                      id: 'active-switch-' + scope.$index,
                      modelValue: newObject.value.active,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newObject.value.active) = $event)),
                      "active-color": "#5022a6",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["id", "modelValue"]))
                  : (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 1,
                      id: 'active-switch-' + scope.$index,
                      modelValue: scope.row.active,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.active) = $event),
                      disabled: 
                !_unref(hasPermission)('ORGANIZATIONS.LIST.INLINE.CHANGE_ACTIVE')
              ,
                      "active-color": "#5022a6",
                      onClick: _withModifiers(($event: any) => (changeActiveStatus(scope.row)), ["stop"])
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "onClick"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              prop: "actions",
              width: "335px"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(ElInput), {
                    id: "search-input",
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                    placeholder: _unref(t)('Common.TypeToSearch'),
                    onInput: _unref(onSearchInput),
                    size: "mini",
                    class: "oneTeg-search-input max-w-170"
                  }, null, 8, ["modelValue", "placeholder", "onInput"]),
                  _createVNode(_unref(ElDivider), {
                    direction: "vertical",
                    class: "v-divider-stretch",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(ElButton), {
                      id: "create-button",
                      class: "no-border btn-oneTeg2-table-create btn-labeled",
                      size: "mini",
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(router).push('/organizations/create')), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_font_awesome_icon, { icon: "plus" })
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("Organization.CreateOrganization")), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  (
                  editMode.value &&
                  scope.row.id === newObject.value.id &&
                  _unref(hasPermission)('ORGANIZATIONS.LIST.INLINE.EDIT')
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ animateBtn: animate.value })
                        }, [
                          _createVNode(_unref(ElButton), {
                            id: 'inline-edit-save-' + scope.$index,
                            class: "btn-oneTeg max-w-42-5",
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(editSelectedOrganization, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "check" })
                            ]),
                            _: 2
                          }, 1032, ["id"]),
                          _createVNode(_unref(ElButton), {
                            id: 'inline-edit-back-' + scope.$index,
                            class: "btn-oneTeg margin-left-3",
                            "native-type": "submit",
                            size: "mini",
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (closeEditMode()), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "times" })
                            ]),
                            _: 2
                          }, 1032, ["id"])
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_unref(ElDropdown), null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                (_unref(hasPermission)('ORGANIZATIONS.LIST.EDIT'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 0,
                                      id: 'edit-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (
                          _unref(router).push('/organizations/edit/' + scope.row.id)
                        ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_unref(hasPermission)('ORGANIZATIONS.LIST.REMOVE'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 1,
                                      id: 'remove-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (deleteSelectedOrganization(scope.row)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              id: 'gear-icon-' + scope.$index,
                              class: "no-border btn-oneTeg show-on-row-hover",
                              size: "mini",
                              type: "primary",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "cog" })
                              ]),
                              _: 2
                            }, 1032, ["id"])
                          ]),
                          _: 2
                        }, 1024),
                        (scope.row.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                                alt: "Loading...",
                                class: "loader-logo-25"
                              }, null, 8, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "default-sort", "empty-text", "row-class-name"]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(OneTegPagination, {
            "page-sizes": [10, 25, 50, 100],
            "page-size": perPageOrganizations.value,
            "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((perPageOrganizations).value = $event)),
            total: numberOfOrganizations.value,
            "current-page": currentPageOrganizations.value,
            "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((currentPageOrganizations).value = $event)),
            background: true,
            small: true,
            onSizeChange: sizeChanged,
            onCurrentChange: getOrganizations,
            layout: 'total, sizes, prev, pager, next'
          }, null, 8, ["page-size", "total", "current-page"])
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_20)
    ], 512), [
      [_vShow, loadingOrganizations.value]
    ])
  ]))
}
}

})